import { colors, darkThemeSelector, styled } from '../../../stitches.config';
import { Body } from '../../../text/Body';
import { Small } from '../../../text/Small';

const FieldLabel = styled('label', {
  color: colors.headingNeutralLight,
  fontWeight: '$bold',

  [darkThemeSelector]: {
    color: colors.headingNeutralDark,
  },

  variants: {
    clickable: {
      true: {
        cursor: 'pointer',
      },
      false: {},
    },
    internal: {
      true: {
        color: colors.internalHeadingLight,

        [darkThemeSelector]: {
          color: colors.internalHeadingDark,
        },
      },
      false: {},
    },
  },
});

const FieldDescription = styled(Small, {
  variants: {
    internal: {
      true: {
        color: colors.internalBodyLight,

        [darkThemeSelector]: {
          color: colors.internalBodyDark,
        },
      },
    },
  },
});

/** Primary composites */
export const PrimaryFieldLabel = styled(FieldLabel, Body);
PrimaryFieldLabel.displayName = 'PrimaryFieldLabel';
export const PrimaryFieldDescription = styled(FieldDescription);
PrimaryFieldDescription.displayName = 'PrimaryFieldDescription';

/** Secondary composites */
export const SecondaryFieldLabel = styled(FieldLabel, Small);
SecondaryFieldLabel.displayName = 'SecondaryFieldLabel';
export const SecondaryFieldDescription = styled(FieldDescription);
SecondaryFieldDescription.displayName = 'SecondaryFieldDescription';
